import { FilterDropdown } from "Components/Shared/Components/FilterDropdown";
import { TransactionStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const PageResources = Resources.Components.Shared.Filters;
const StatusResources = Resources.Transactions.TransactionStatus;

type Props = {
  value?: TransactionStatus;
  onChange: (value: TransactionStatus | undefined) => void;
};

export const StatusFilterDropdown = ({ value, onChange }: Props) => {
  const { t } = useResource();

  const statusOptions = [
    { value: "", label: t(PageResources.AllStatuses) },
    {
      value: TransactionStatus.Success,
      label: t(StatusResources[TransactionStatus.Success]),
    },
    {
      value: TransactionStatus.Processing,
      label: t(StatusResources[TransactionStatus.Processing]),
    },
    {
      value: TransactionStatus.Created,
      label: t(StatusResources[TransactionStatus.Created]),
    },
    {
      value: TransactionStatus.Initiated,
      label: t(StatusResources[TransactionStatus.Initiated]),
    },
    {
      value: TransactionStatus.Cancelled,
      label: t(StatusResources[TransactionStatus.Cancelled]),
    },
    {
      value: TransactionStatus.Fail,
      label: t(StatusResources[TransactionStatus.Fail]),
    },
    {
      value: TransactionStatus.InvestigationNeeded,
      label: t(StatusResources[TransactionStatus.InvestigationNeeded]),
    },
  ];

  const handleChange = (newValue: string | number) => {
    onChange(newValue === "" ? undefined : (newValue as TransactionStatus));
  };

  return (
    <FilterDropdown
      label={t(PageResources.Status)}
      options={statusOptions}
      value={value ?? ""}
      onChange={handleChange}
      placeholder={t(PageResources.AllStatuses)}
    />
  );
};
